export default __webpack_public_path__ + "static/media/SuisseIntl-SemiBoldItalic-WebXL.05662cc8.woff2";